"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SetRootPadding = exports.HideOnScroll = exports.HeaderMethods = exports.HandleSetter = exports.GetTestIdValues = void 0;
var HeaderMethods = _interopRequireWildcard(require("./Header"));
exports.HeaderMethods = HeaderMethods;
var HeaderStyles = _interopRequireWildcard(require("./HeaderStyles"));
var _Category = _interopRequireDefault(require("../Navigation/Category"));
var _CookieAcknowledge = _interopRequireDefault(require("../CookieAcknowledge/CookieAcknowledge"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _Navigation = _interopRequireDefault(require("../Navigation/Navigation"));
var _NavigationMobile = _interopRequireDefault(require("../NavigationMobile/NavigationMobile"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SiteAlerts = _interopRequireDefault(require("../SiteAlerts/SiteAlerts"));
var _SkipLinks = _interopRequireDefault(require("../SkipLinks/SkipLinks"));
var _classnames = _interopRequireDefault(require("classnames"));
var _array = require("../../utils/type-checks/array");
var _function = require("../../utils/type-checks/function");
var _string = require("../../utils/type-checks/string");
var _throttle = require("../../utils/performance/throttle");
var _useElementSize = require("../../utils/hooks/useElementSize");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _Search = _interopRequireWildcard(require("./../Search/Search"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  GetTestIdValues = testId => {
    return {
      componentTestId: testId ? testId : undefined,
      categoryComponentTestId: testId ? `${testId}_category-component` : undefined,
      categorySpanTestId: testId ? `${testId}_category-span` : undefined,
      logoTestId: testId ? `${testId}__logo` : undefined,
      navigationTestId: testId ? `${testId}_navigation` : undefined,
      navigationMobileTestId: testId ? `${testId}_navigationMobile` : undefined,
      supplementalTestId: testId ? `${testId}_supplementalNavigation` : undefined
    };
  },
  SetRootPadding = height => {
    const rootNode = document.querySelector("html"),
      rootStyles = rootNode.style;
    let newHeight;
    if (!Number.isNaN(parseInt(height, 10)) && rootStyles) {
      newHeight = parseInt(height, 10);
      rootNode.style.paddingTop = `${newHeight}px`;
      rootNode.style.scrollPaddingTop = `${newHeight + 20}px`;
    } else {
      newHeight = null;
    }
    return newHeight;
  },
  HandleSetter = (value, setter) => {
    let result = null;
    if ((value || value === false) && (0, _function.isFunction)(setter)) {
      setter(value);
      result = true;
    }
    return result;
  },
  HideOnScroll = props => {
    const {
        children,
        collapseSpeed = 0,
        height = 50,
        testId
      } = props,
      [isVisible, setIsVisible] = (0, _react.useState)(window.scrollY <= height);
    (0, _react.useEffect)(() => {
      const onScroll = () => {
        (0, _throttle.throttle)(HeaderMethods.HandleSetter(window.scrollY <= height, setIsVisible), 50);
      };
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, [height, isVisible, setIsVisible]);
    return /*#__PURE__*/_react.default.createElement(_material.Collapse, {
      className: "collapse-on-scroll",
      "data-testid": testId,
      in: isVisible,
      timeout: collapseSpeed
    }, children);
  };

/**
 * Sitewide Page Header Component
 *
 * @visibleName Page Header
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.HideOnScroll = HideOnScroll;
exports.HandleSetter = HandleSetter;
exports.SetRootPadding = SetRootPadding;
exports.GetTestIdValues = GetTestIdValues;
const Header = props => {
  const {
      bundledStyles = {},
      categoryArray = [],
      className,
      collapseSpeed,
      CookieAcknowledgeProps = {},
      customTheme = {},
      defaultCategory = undefined,
      defaultIsDesktop = true,
      defaultSubCategory,
      enableSearch = false,
      logo = {
        alt: "The Pennsylvania Higher Education Assistance Agency",
        src: `${process.env.PUBLIC_URL}/general/images/header/logo.svg`,
        height: {
          xs: "5.8rem",
          md: "6.3rem"
        },
        width: {
          xs: "17rem",
          md: "18.4rem"
        }
      },
      mobileCategoryArray = [],
      mobileVariant = "default",
      navigationBreakpoint = 0,
      onHeightChange,
      searchId = "search_form",
      searchProps,
      searchTarget = "_self",
      signInFragmentId = "s4t6iy",
      SitewideAlerts = props => /*#__PURE__*/_react.default.createElement(_SiteAlerts.default, props),
      skipLinksArray = undefined,
      supplementalFragment = "13dqqi7",
      supplementalPosition = "top",
      testId,
      variant = "default"
    } = props,
    {
      bundledCategoryStyles,
      bundledNavigationStyles,
      bundledNavigationMobileStyles,
      customAppBarStyles = {},
      customCategoryStyles = {},
      customContainerStyles = {},
      customInnerContainerStyles = {},
      customLogoStyles = {},
      customLogoImageStyles = {},
      customMenuParentStyles = {},
      customSupplementalListStyles = {}
    } = bundledStyles,
    [category, setCategory] = (0, _react.useState)(!defaultCategory && categoryArray.length > 0 && (0, _string.isStringOfLength)(categoryArray[0].value) ? categoryArray[0].value : defaultCategory),
    testIdMap = GetTestIdValues(testId),
    theme = merge((0, _styles.useTheme)(), customTheme),
    appBarStyles = merge(HeaderStyles.DefaultAppBarStyles(theme), customAppBarStyles),
    categoryStyles = merge.all([HeaderStyles.DefaultContainerStyles(theme), HeaderStyles.DefaultCategoryStyles(theme), customCategoryStyles]),
    containerStyles = merge(HeaderStyles.DefaultContainerStyles(theme), customContainerStyles),
    innerContainerStyles = merge(HeaderStyles.DefaultInnerContainerStyles(theme), customInnerContainerStyles),
    logoStyles = merge(HeaderStyles.DefaultLogoStyles(theme), customLogoStyles),
    supplementalListStyles = merge(HeaderStyles.DefaultSupplementalListStyles(theme), customSupplementalListStyles),
    containerId = "navigation__menu-parent-ref",
    signInId = "navigation__sign-in-parent-ref",
    [headerRef, {
      height
    }] = (0, _useElementSize.useElementSize)(),
    mobileArray = (0, _array.isArrayOfLength)(mobileCategoryArray) ? mobileCategoryArray : merge([], categoryArray),
    mobileIndicator = (0, _array.isArrayOfLength)(mobileCategoryArray) ? "custom" : "default",
    supplementAtTop = (0, _string.isStringOfLength)(supplementalFragment) && (supplementalPosition && supplementalPosition === "top" || (0, _string.isStringOfLength)(signInFragmentId)),
    origDesktop = (0, _useMediaQuery.default)(`(min-width:${theme.breakpoints.values.md}${theme.breakpoints.unit}`),
    suppliedDesktop = (0, _useMediaQuery.default)(`(min-width:${typeof navigationBreakpoint === "number" ? navigationBreakpoint + "px" : navigationBreakpoint}`),
    compiledClasses = (0, _classnames.default)({
      "site-header": true,
      [`${className}`]: className
    }),
    handleCategory = e => HeaderMethods.HandleSetter(e?.target?.value, setCategory);
  let categoryAdjustment,
    logoImageStyles = merge.all([{
      height: logo.height,
      width: logo.width
    }, HeaderStyles.DefaultLogoImageStyles(theme), customLogoImageStyles]),
    menuParentStyles,
    isDesktop = origDesktop;
  if (navigationBreakpoint !== 0) {
    isDesktop = suppliedDesktop;
  }
  menuParentStyles = merge(HeaderStyles.DefaultMenuParentStyles(isDesktop && defaultIsDesktop ? "flex-start" : "space-between"), customMenuParentStyles);
  categoryAdjustment = categoryArray.length > 1 ? {
    justifyContent: "space-between"
  } : {
    justifyContent: "flex-end"
  };
  (0, _react.useLayoutEffect)(() => {
    HeaderMethods.SetRootPadding(height);
    if ((0, _function.isFunction)(onHeightChange)) {
      onHeightChange(height);
    }
    return () => {
      SetRootPadding(0);
    };
  }, [height, onHeightChange]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_CookieAcknowledge.default, _extends({}, CookieAcknowledgeProps, {
    customTheme: customTheme
  })), /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    className: compiledClasses,
    component: "header",
    "data-testid": testIdMap.componentTestId,
    id: containerId,
    position: "fixed",
    ref: headerRef,
    role: "banner",
    sx: appBarStyles
  }, /*#__PURE__*/_react.default.createElement(_SkipLinks.default, {
    customTheme: customTheme,
    skipLinksArray: skipLinksArray
  }), SitewideAlerts && /*#__PURE__*/_react.default.createElement(HideOnScroll, {
    collapseSpeed: collapseSpeed,
    height: height
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "site-header__alerts",
    component: "div",
    sx: {
      display: "block"
    }
  }, /*#__PURE__*/_react.default.createElement(SitewideAlerts, {
    customTheme: customTheme
  }))), (categoryArray.length > 1 || supplementAtTop) && isDesktop && defaultIsDesktop === true && variant !== "no-navigation" && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(HideOnScroll, {
    collapseSpeed: collapseSpeed,
    height: height
  }, /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: "category__container",
    sx: categoryStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testIdMap.categorySpanTestId,
    className: "category__container-wrap",
    sx: merge(innerContainerStyles, categoryAdjustment)
  }, categoryArray.length > 1 && /*#__PURE__*/_react.default.createElement(_Category.default, {
    bundledStyles: bundledCategoryStyles,
    categoryArray: categoryArray.map(item => {
      return {
        label: item.label,
        value: item.value,
        fragments: item.fragments
      };
    }),
    customInnerContainerStyles: innerContainerStyles,
    "data-testid": testIdMap.categoryComponentTestId,
    onClick: handleCategory,
    selectedCategory: category
  }), supplementalPosition && supplementalPosition === "top" && /*#__PURE__*/_react.default.createElement(_material.Box, {
    "aria-label": "Sitewide Header Links",
    component: "nav",
    "data-testid": testIdMap.supplementalTestId,
    sx: supplementalListStyles
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: supplementalFragment
  })))))), /*#__PURE__*/_react.default.createElement(_material.Container, {
    sx: containerStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: merge(innerContainerStyles, menuParentStyles),
    id: signInId
  }, /*#__PURE__*/_react.default.createElement(_material.Card, {
    component: "h1",
    sx: logoStyles
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/"
  }, /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    alt: logo.alt,
    className: "header__logo",
    component: "img",
    "data-testid": testIdMap.logoTestId,
    src: logo.src,
    sx: logoImageStyles
  }))), isDesktop && defaultIsDesktop === true && variant !== "no-navigation" && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    bundledStyles: bundledNavigationStyles,
    categoryArray: categoryArray.filter(item => item.value === category),
    customTheme: customTheme,
    enableSearch: enableSearch,
    testId: testIdMap.navigationTestId,
    defaultAnchorId: containerId,
    defaultSignInAnchorId: signInId,
    defaultSubCategory: defaultSubCategory,
    headerOffset: height,
    signInFragmentId: signInFragmentId,
    supplementalFragment: supplementalFragment,
    supplementalListStyles: supplementalListStyles,
    supplementalPosition: supplementalPosition,
    supplementalTestId: testIdMap.supplementalTestId
  })), (!isDesktop || defaultIsDesktop === false) && variant !== "no-navigation" && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end"
    }
  }, enableSearch && /*#__PURE__*/_react.default.createElement(_Search.SearchButton, {
    className: "Search--isMobile",
    customTheme: customTheme,
    searchId: searchId,
    testid: testIdMap.searchButton
  }), /*#__PURE__*/_react.default.createElement(_NavigationMobile.default, {
    bundledStyles: bundledNavigationMobileStyles,
    categoryArray: mobileArray,
    customTheme: customTheme,
    indicator: mobileIndicator,
    isDesktop: isDesktop && defaultIsDesktop,
    testId: testIdMap.navigationMobileTestId,
    logo: logo,
    onCategoryClick: handleCategory,
    defaultSubCategory: defaultSubCategory,
    searchId: searchId,
    signInFragmentId: signInFragmentId,
    supplementalFragment: supplementalFragment,
    variant: mobileVariant
  })), enableSearch && /*#__PURE__*/_react.default.createElement(_Search.default, _extends({}, searchProps, {
    searchId: searchId,
    customTheme: customTheme,
    defaultAnchorId: "navigation__menu-parent-ref",
    target: searchTarget
  }))))));
};

// Define propTypes;
Header.propTypes = {
  /** Bundled custom style objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Bundled category list styles */
    bundledCategoryStyles: _propTypes.default.shape({
      customCategoryStyles: _propTypes.default.object,
      customCategoryListStyles: _propTypes.default.object,
      customCategoryButtonStyles: _propTypes.default.object
    }),
    /** Custom navigation styles */
    bundledNavigationStyles: _propTypes.default.object,
    /** Custom mobile navigation styles */
    bundledNavigationMobileStyles: _propTypes.default.object,
    /** Custom app bar component styles */
    customAppBarStyles: _propTypes.default.object,
    /** Custom category list wrapping styles */
    customCategoryStyles: _propTypes.default.object,
    /** Custom outer container styles */
    customContainerStyles: _propTypes.default.object,
    /** Custom inner container styles */
    customInnerContainerStyles: _propTypes.default.object,
    /** Custom logo block styles */
    customLogoStyles: _propTypes.default.object,
    /** Custom menu block styles */
    customMenuParentStyles: _propTypes.default.object
  }),
  /** Category array for building menu category list (Default Value: []) */
  categoryArray: _propTypes.default.array,
  /** Property Object for Cookie Acknowledge component (Default Value: {}) */
  CookieAcknowledgeProps: _propTypes.default.shape({
    /** Button Label */
    buttonLabel: _propTypes.default.string,
    /** Boolean to disable cookie acknowledge display */
    disabled: _propTypes.default.bool,
    /** Content Fragment ID */
    fragmentId: _propTypes.default.string,
    /** Header Text */
    headerTitle: _propTypes.default.string,
    /** Key for storing acceptance in localStorage */
    key: _propTypes.default.string,
    /** Custom Style Object */
    styles: _propTypes.default.object
  }),
  /** Speed for hide on scroll elements to animate */
  collapseSpeed: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** Theme injection object */
  customTheme: _propTypes.default.object,
  /** Default category label */
  defaultCategory: _propTypes.default.string,
  /** @ignore */
  defaultIsDesktop: _propTypes.default.bool,
  /** Default sub-category label */
  defaultSubCategory: _propTypes.default.string,
  /** Boolean to enable search window (Default Value: false) */
  enableSearch: _propTypes.default.bool,
  /** Object describing logo attributes */
  logo: _propTypes.default.shape({
    /** Image alt. text (Default Value: "The Pennsylvania Higher Education Assistance Agency") */
    alt: _propTypes.default.string.isRequired,
    /** Image height (Default Value: {xs: "8.8rem", md: "6.3rem"}) */
    height: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.number.isRequired, _propTypes.default.object]).isRequired,
    /** Image URL path (Default Value: "/general/images/header/logo.svg") */
    src: _propTypes.default.string.isRequired,
    /** Image width (Default Value: {xs: "17rem", md: "18.4rem"}) */
    width: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.number.isRequired, _propTypes.default.object]).isRequired
  }),
  /** Category array for building separate menu category list (Default Value: []) */
  mobileCategoryArray: _propTypes.default.array,
  /** Mobile Navigation Variant */
  mobileVariant: _propTypes.default.oneOf(["default", "default--noHeader", "inverse", "inverse--noHeader"]),
  /** Breakpoint for desktop/mobile navigation switch (defaults to theme.breakpoint.md) */
  navigationBreakpoint: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** Method that processes any height change */
  onHeightChange: _propTypes.default.func,
  /** String for search component ID value */
  searchId: _propTypes.default.string,
  /** Object containing props to pass to search for customization */
  searchProps: _propTypes.default.shape({
    /** Boolean to open window on load */
    autoOpen: _propTypes.default.bool,
    /** URL for Background Image */
    backgroundImagePath: _propTypes.default.string,
    /** DOM ID for Button */
    buttonId: _propTypes.default.string,
    /** Custom classname(s) */
    className: _propTypes.default.string,
    /** Default search value */
    defaultSearchValue: _propTypes.default.string,
    /** Placeholder Text */
    placeholderText: _propTypes.default.string,
    /** Custom styles for popper window */
    popperBoxStyles: _propTypes.default.object,
    /** Custom styles for component */
    styles: _propTypes.default.object
  }),
  /** Target of search results (Default Value: "_self") */
  searchTarget: _propTypes.default.oneOf(["_blank", "_self"]),
  /** Content fragment for handling consumer sign-in options (Default Value: "s4t6iy") */
  signInFragmentId: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Component containing site alert logic (Default Value: props => <SiteAlerts {...props} />) */
  SitewideAlerts: _propTypes.default.any,
  /** Array of page skip links */
  skipLinksArray: _propTypes.default.array,
  /** Content Fragment ID containing supplimental navigation links (Default Value: "13dqqi7") */
  supplementalFragment: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  /** Position of supplimental links section (Default Value: "top") */
  supplementalPosition: _propTypes.default.oneOf(["right", "top"]),
  /** @ignore */
  testId: _propTypes.default.string
};
HideOnScroll.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  collapseSpeed: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.number,
  testId: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["default", "no-navigation"])
};

// Export component as default;
var _default = exports.default = Header;